import { useState } from 'react';
import './Contact.css';
import { FaWhatsapp } from 'react-icons/fa';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const whatsappNumber = '+255718665620';

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    const text = `Hello, I have an inquiry:
Name: ${form.name}
Email: ${form.email}
Phone: ${form.phone}
Subject: ${form.subject}
Message: ${form.message}`;
    const sanitizedNumber = whatsappNumber.replace(/\D/g, '');
    window.open(`https://wa.me/${sanitizedNumber}?text=${encodeURIComponent(text)}`, '_blank');
    setSent(true);
    setForm({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <div className="contact-image">
          <img src="/images/cover6.jpg" alt="Contact Haji" />
        </div>

        <div className="contact-form-card">
          <h2>Contact Us</h2>
          <p className="muted">Share your travel dates, interests and group size—we’ll craft a stress-free journey.</p>

          {sent && <div className="alert">Your inquiry has been opened in WhatsApp. Send it to reach us directly!</div>}

          <form className="form" onSubmit={onSubmit}>
            <div className="form-group">
              <input name="name" value={form.name} onChange={onChange} required />
              <label>Name</label>
            </div>

            <div className="form-group">
              <input type="email" name="email" value={form.email} onChange={onChange} required />
              <label>Email</label>
            </div>

            <div className="form-group">
              <input name="phone" value={form.phone} onChange={onChange} />
              <label>Phone</label>
            </div>

            <div className="form-group">
              <input name="subject" value={form.subject} onChange={onChange} />
              <label>Subject</label>
            </div>

            <div className="form-group textarea-group">
              <textarea name="message" value={form.message} onChange={onChange} required rows="5" />
              <label>Message</label>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn">
                <FaWhatsapp /> Send via WhatsApp
              </button>
            </div>
          </form>

          <div className="contact-details">
            <h3>Contact Details</h3>
            <p><strong>Phone:</strong> +255 682 837 935</p>
            <p><strong>Email:</strong> savijuma5@gmail.com</p>
            <p><strong>Address:</strong> Zanzibar, Tanzania</p>
          </div>
        </div>
      </div>
    </section>
  );
}
